module.exports = __webpack_public_path__ + "img/social-wechat-qr.482b6625.jpg";